import React, { useState } from "react";
import { Container } from "../styled.ts";
import { Typography } from "../typography/index.tsx";
import { useMobile } from "../../hooks/isMobile.tsx";

interface Testimonial {
  quote: string;
  name: string;
  role: string;
}

const testimonials: Testimonial[] = [
  {
    quote: "I never miss a critical announcement anymore. FinQ alerts me instantly on WhatsApp - game changer!",
    name: "Rajesh K.",
    role: "Active Trader",
  },
  {
    quote: "The free trial convinced me. Now I track 50 stocks and get alerts in real-time.",
    name: "Priya S.",
    role: "Long-term Investor",
  },
  {
    quote: "Best part? No spam, just stock alerts. Exactly what I needed to stay on top of my portfolio.",
    name: "Amit M.",
    role: "Portfolio Manager",
  },
];

const TestimonialCard = ({ testimonial }: { testimonial: Testimonial }) => (
  <Container
    column
    padding="20px"
    background="#f8f9fa"
    radius="16px"
    gap="12px"
    width="100%"
  >
    <Typography
      tag="p"
      fontFamily="Neue Montreal"
      fontSize="15px"
      fontWeight={400}
      lineHeight="23px"
      color="#555"
      fontStyle="italic"
    >
      "{testimonial.quote}"
    </Typography>
    <Container gap="8px" alignItems="center">
      <Container
        width="36px"
        height="36px"
        radius="18px"
        background="linear-gradient(165.56deg, #5395FF 39.75%, #D69DFF 58.69%)"
        alignItems="center"
        justifyContent="center"
      >
        <Typography
          tag="span"
          fontFamily="Neue Montreal"
          fontSize="14px"
          fontWeight={600}
          color="#fff"
        >
          {testimonial.name.charAt(0)}
        </Typography>
      </Container>
      <Container column gap="2px">
        <Typography
          tag="p"
          fontFamily="Neue Montreal"
          fontSize="14px"
          fontWeight={600}
          color="#202020"
        >
          {testimonial.name}
        </Typography>
        <Typography
          tag="p"
          fontFamily="Neue Montreal"
          fontSize="12px"
          fontWeight={400}
          color="#828282"
        >
          {testimonial.role}
        </Typography>
      </Container>
    </Container>
  </Container>
);

const Testimonials = () => {
  const { isMobile } = useMobile();
  const [currentIndex, setCurrentIndex] = useState(0);

  // Mobile: stacked cards (most readable)
  if (isMobile) {
    return (
      <Container column gap="12px" width="100%">
        {testimonials.map((testimonial, index) => (
          <TestimonialCard key={index} testimonial={testimonial} />
        ))}
      </Container>
    );
  }

  // Desktop: carousel
  return (
    <Container column alignItems="center" gap="30px" width="100%">
      <Container
        width="100%"
        maxWidth="800px"
        style={{ overflow: "hidden" }}
      >
        <Container
          width={`${testimonials.length * 100}%`}
          style={{
            display: "flex",
            transform: `translateX(-${(currentIndex * 100) / testimonials.length}%)`,
            transition: "transform 0.5s ease-in-out",
          }}
        >
          {testimonials.map((testimonial, index) => (
            <Container
              key={index}
              width={`${100 / testimonials.length}%`}
              justifyContent="center"
              padding="0 40px"
              style={{ flexShrink: 0 }}
            >
              <TestimonialCard testimonial={testimonial} />
            </Container>
          ))}
        </Container>
      </Container>

      {/* Dots indicator */}
      <Container gap="8px" justifyContent="center" alignItems="center">
        {testimonials.map((_, index) => (
          <div
            key={index}
            style={{
              width: index === currentIndex ? "24px" : "8px",
              height: "8px",
              borderRadius: "4px",
              background: index === currentIndex ? "#5395FF" : "#E0E0E0",
              cursor: "pointer",
              transition: "all 0.3s ease",
            }}
            onClick={() => setCurrentIndex(index)}
          />
        ))}
      </Container>
    </Container>
  );
};

export default Testimonials;
